import React from 'react';
import { Facebook, Twitter, Linkedin, Mail, Link2, Check } from 'lucide-react';

const SocialShare = ({ title, url }) => {
  const [copied, setCopied] = React.useState(false);
  
  const shareUrl = url || window.location.href;
  const shareTitle = encodeURIComponent(title || document.title);
  const encodedUrl = encodeURIComponent(shareUrl);

  const shareLinks = [
    {
      name: 'Facebook',
      icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      color: 'hover:bg-blue-600'
    },
    {
      name: 'Twitter',
      icon: Twitter,
      url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${shareTitle}`,
      color: 'hover:bg-sky-500'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      color: 'hover:bg-blue-700'
    },
    {
      name: 'Email',
      icon: Mail,
      url: `mailto:?subject=${shareTitle}&body=Check out this article: ${encodedUrl}`,
      color: 'hover:bg-teal-600'
    }
  ];

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="social-share">
      <span className="text-sm text-slate-500 mr-2">Share:</span>
      {shareLinks.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`p-2 rounded-full bg-slate-100 text-slate-600 hover:text-white transition-colors ${link.color}`}
          aria-label={`Share on ${link.name}`}
          data-testid={`share-${link.name.toLowerCase()}`}
        >
          <link.icon className="w-4 h-4" />
        </a>
      ))}
      <button
        onClick={copyToClipboard}
        className={`p-2 rounded-full transition-colors ${
          copied 
            ? 'bg-green-500 text-white' 
            : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
        }`}
        aria-label="Copy link"
        data-testid="share-copy-link"
      >
        {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default SocialShare;
